import React, { useState } from "react";

import Header from "../../Common/Header";
import Footer from "../../Common/Footer";
import { Link } from "react-router-dom";

import { useRef } from "react";

import { useLocation } from "react-router-dom";

import axios from "axios";
import { ApiContext } from "../../Context/Context";
import { use, useContext, useEffect } from "react";
import {
  getRecords,
  PostRecords,
  uploadMultipleFiles,
} from "../../Services/ApiCall";
import FeaturedProperty from "../../Common/FeaturedProperties";
import ProjectsComp from "../../Common/Projects";
import NearByProperties from "../../Common/NearByProperties";
import {
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
  BaseUrl,
  apiUrl_dialerp,
  setLogindata,
  setUserdata,
  apiTest_Url,
  Authorization_Token,
  Dialerp_IN_Token,
  subID,
} from "../../Services/Urls";
import FilterParams from "../../Classes/FilterParams";
import { useNavigate } from "react-router-dom";

import { TailSpin } from "react-loader-spinner";
import SelectDialog from "../../Common/SelectDialog ";
import AmenitiesDialog from "../../Common/AmenitiesDialog";
import { decryptOtp, formatDaysAgo } from "../../Services/Helper";
import {
  callApi,
  makeApiRequest,
  callAzureOpenAI,
} from "../../Services/ApiService";

import { toast } from "react-toastify";
import SucessDialog from "../../Common/Dialog/SucessDialog";
import {
  formatIndianAmount,
  removeSpecialCharacters,
} from "../../Services/Helper";
import "./walletstyle.css";


const Wallet = () => {
  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    CityData,

    coordinates,

    Locality,

    Area,
  } = useContext(ApiContext);
  const [amount, setamount] = useState("");
  const [loading, setloading] = useState(false);

  const [walletData, setwalletData] = useState(null);
  const [Transactions, setTransactions] = useState([]);

  useEffect(() => {
    getwalletdetails();
    getTransactions();
  }, []);

  const getTransactions = () => {
    const url = `${apiUrl_dialerp}/api/Dynamic/GetRecords?tabErpID=2254&tabName=Transactions%20(Orders)`;
    const body = {
      pgSize: 2,
      viewFormat: "columnname",
      filterButtons: "",
      index: 1,
      toEmailID: "admin@dialerp.com",
      tabErpID: 2254,
      useAtlusSearch: false,
      RoleID: 0,
      LedgerID: 1002,
      order: -1,
      orderBy: "",
      processID: 1,
      filters: `{LedgerID: { $in: [${userData?.UserID}] }}`,
    };

    callApi(url, body, Dialerp_IN_Token, (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setTransactions(data?.response?.records || []);
          setloading(false);
        } else {
          setTransactions([]);
          setloading(false);
          console.log("Error in fetching featured properties", data);
        }
      } else {
        setloading(false);
      }
    });
  };

  const getwalletdetails = () => {
    const filter = `{UserID: { $in: [${LoggedInUserID}] }}`;

    getRecords(437, 1, filter, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setwalletData(data?.response?.records[0] || null);
          setloading(false);
        } else {
          setwalletData(null);
          setloading(false);
          console.log("Error in fetching featured properties", data);
        }
      } else {
        setloading(false);
      }
    });
  };

  const handlePayment = () => {
      setloading(true);
    // let UserData: any = getUser();
    const body = {
      amount: parseInt(amount),
      parentID: subID,
      cName: userData?.User,
      mobileNo: 8851354099,
      emailID: userData?.Email || "kushagr2017@gmail.com",
      compnayName: "LandPanda",
      //empPartyACTBSr: 17,
      purposeOfPay: "Wallet Topup",
      Phone: userData?.Mobile,
      Email: userData?.Email || "kushagr2017@gmail.com",
      FirstName: userData?.User,
      cByName: userData?.User,
      cNameID: userData?.UserID,
      BillToLedgerID: userData?.UserID,
      SubDomain: "LandPanda",
      ClientSubscriberID: subID,
      SubscriberID: 10001,
      toEmailID: "rahulbisht.lp1@gmail.co",
    };

    const url = `${apiTest_Url}/api/WebApi/paySplitPaymentClient_landpanda`;
    console.log(body);

    callApi(
      url,
      body,
      Authorization_Token,
      (response) => {
        if (response?.hasErrors == false && response != null) {
          if (response?.response?.status == 1) {
               setloading(false);
            //  localStorage.setItem("SOD-UniversalDairy", JSON.stringify(payBody));
            var url = "https://pay.easebuzz.in/pay/" + response?.response?.data;

            window.open(url, "_self");
          }
        } else {
             setloading(false);
          //setLoading(false);
          alert(response?.errors ?? "unknown error occurs");
        }
      },
      (error) => {   setloading(false);},
    );
  };

  const addMoney = () => {
    let body = null;

    if (walletData != null) {
      body = [
        {
          WalletID: walletData?.WalletID,

          Balance:
            parseFloat(walletData?.Balance || "0") + parseFloat(amount || "0"),
          TotalCredited:
            parseFloat(walletData?.TotalCredited || "0") +
            parseFloat(amount || "0"),
        },
      ];
    } else {
      body = [
        {
          User: userData?.User,
          UserID: userData?.UserID,
          Balance: parseFloat(amount),
          TotalCredited: parseFloat(amount),
          TotalDebited: 0,
          Status: "Active",
          StatusID: 1,
        },
      ];
    }

    PostRecords(437, 1, body, (data) => {
      if (data != null && data?.response?.hasErrors === false) {
        toast.success(`${"Balance Added Successfully"}`);
        getwalletdetails();
      } else {
        toast.error(`${data?.response?.errors}`);
      }
    });
  };

  return (
    <div className="page-wrapper">
      <Header />

      <section className="wallet-wrap ptb-100">
        <div className="container">
          <div className="wallet-grid">
            {/* LEFT - WALLET */}
            <div className="wallet-left">
              {/* Balance Card */}
              <div className="wallet-card">
                <h3 style={{ color: "white" }}>My Wallet</h3>
                <p style={{ color: "white" }} className="label">
                  Current Balance
                </p>
                <h1 className="balance">₹ {walletData?.Balance || 0.0}</h1>

                <div className="wallet-actions">
                  <input
                    value={amount}
                    onChange={(e) => setamount(e.target.value)}
                    type="number"
                    placeholder="Enter amount"
                  />
                  <button
                    disabled={!amount}
                    onClick={() =>
                      //addMoney()
                      handlePayment()
                    }
                    className="add-btn"
                  >
                    Add Money
                  </button>
                </div>
              </div>

              {/* Transactions */}
              <div className="transactions">
                <h4>Recent Transactions</h4>

                {Transactions?.map((data, i) => {
                  return (
                    <div key={i} className="txn">
                      <div>
                        <p>ID : {data?.MerchantTransactionID}</p>
                        <p>Status : {data?.TransactionStatus}</p>

                        <span>{formatDaysAgo(data?.cDt?.split(" ")[0])}</span>
                      </div>
                      <div className="credit">+ ₹ {data?.Amount || 0.0}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* RIGHT - INFO PANEL */}
            <div className="wallet-right">
              {/* <div className="info-box">
                <h4>Quick Actions</h4>
                <button className="full-btn">Send Money</button>
                <button className="full-btn">Withdraw</button>
              </div> */}

              <div className="info-box">
                <h4>Wallet Info</h4>
                <p>
                  Status: <b>{walletData?.Status || ""}</b>
                </p>
                <p>
                  Last Updated: {formatDaysAgo(walletData?.cDt?.split(" ")[0])}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

       {loading && (
              <div
                style={{
                  position: "fixed",
                  inset: 0,
                  backgroundColor: "rgba(255,255,255,0.7)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 9999,
                }}
              >
                <TailSpin color="#00BFFF" height={80} width={80} />
              </div>
            )}

    </div>
  );
};

export default Wallet;
